import { PaginationNavigation } from './PaginationNavigation';

interface PaginationProps {
  totalPages: number;
  currentPage: number;
  totalCount: number;
  perPageItems: number;
  onChange: (page: number) => void;
}

export const Pagination = ({
  totalPages,
  currentPage,
  totalCount,
  perPageItems,
  onChange,
}: PaginationProps) => {
  if (totalPages === 0) {
    return null; // No pagination needed if there are no pages
  }

  const startItem = (currentPage - 1) * perPageItems + 1;
  const endItem =
    currentPage === totalPages ? totalCount : currentPage * perPageItems;

  return (
    <div className="flex items-center justify-between bg-transparent">
      <div className="flex max-md:flex-col max-md:gap-2 md:flex-1 md:items-center md:justify-between">
        <div>
          <p className="font-normal text-gray text-sm">
            Showing items from {startItem} to {endItem} out of {totalCount}
          </p>
        </div>
        <div className="hidden md:block">
          <PaginationNavigation
            currentPage={currentPage}
            handlePageChange={onChange}
            maxVisibleElements={9}
            totalPages={totalPages}
          />
        </div>
        <div className="md:hidden">
          <PaginationNavigation
            currentPage={currentPage}
            handlePageChange={onChange}
            maxVisibleElements={5}
            totalPages={totalPages}
          />
        </div>
      </div>
    </div>
  );
};
